import { defineStore } from "pinia";
import AppConfirmModal from "@/components/app/AppConfirmModal.vue";

/**
 * Define initial state data.
 */
const initialState = {
  title: "",
  component: null,
  props: {},
  customClass: null,
  resolveFunc: null,
  rejectFunc: null,
};

export default defineStore("modalStore", {
  state: () => ({ ...initialState }),
  actions: {
    /**
     * Open modal.
     * @param {Object: { title: String, component: Object, props: Object }}
     */
    openModal({ title, component, props, customClass }) {
      this.title = title;
      this.component = component;
      this.props = props;
      this.customClass = customClass
    },
    /**
     * Close modal.
     */
    closeModal() {
      this.title = initialState.title;
      this.component = initialState.component;
      this.props = initialState.props;
      if (this.resolveFunc) this.rejectFunc(false);
    },
    /**
     * Open confirm modal.
     * @param {Object: { title: String, props: Object }}
     * @returns {Promise}
     */
    async openConfirmModal({ title, props }) {
      try {
        const response = await (() => {
          this.openModal({ title, component: AppConfirmModal, props });
          return new Promise((resolve, reject) => {
            this.resolveFunc = resolve;
            this.rejectFunc = reject;
          });
        })();
        return response;
      } catch (error) {
        return false;
      } finally {
        this.closeModal();
      }
    },
  },
  getters: {
    /**
     * Check if modal is open.
     * @returns {Boolean}
     */
    isOpen: (state) => state.component !== null,
  },
});
